export const LEGAL_CANCELLATION_REFUND_POLICY: string = `

### <!--= ++sectionIndex -->. Rückerstattungsrichtlinie

In diesem Abschnitt werden die spezifischen Bedingungen und Anforderungen erläutert, die für die Rückerstattungsrichtlinie für unsere Produkte gelten. Es ist unbedingt erforderlich, dass Sie diese Bedingungen gründlich lesen. Ihr Anspruch auf eine Rückerstattung in Bezug auf die gekauften Produkte hängt von diesen festgelegten Bedingungen ab.

Bitte beachten Sie: Falls unten keine spezifischen Bedingungen aufgeführt sind, bedeutet dies, dass für Ihr spezifisches Produkt oder Ihren Kauf keine zusätzlichen oder besonderen Bedingungen gelten.

<!-- subSectionIndex = 0; -->

<!-- if (cancellationPolicy.refundPolicies) { -->

<!-- for (const refundPolicy of cancellationPolicy.refundPolicies) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. <!--= refundPolicy.heading -->

<!-- for (const textLine of refundPolicy.texts) { -->
<!--= textLine -->

<!-- } -->

<!-- } -->

<!-- } -->
`;
